import PropTypes from 'prop-types';
import { Crown } from 'lucide-react';
import { cn } from '@/lib/utils';
import { VIP_LABEL } from '@/constants/vip';

/**
 * The VIP pill (src/constants/vip.js), the same for staff and for the
 * customer's own badge. Founder's pick (2026-10-25): a matte gold pill with
 * dark letters and a small crown. Flat on purpose, no gloss, glow or
 * animation. `title` is the hover text; `srText` follows "VIP" for screen
 * readers.
 */
export default function VipPill({ title = 'VIP customer', srText = ' customer', className }) {
  return (
    <span
      className={cn(
        'inline-flex flex-shrink-0 items-center gap-1 rounded-full bg-gradient-to-b from-[#dcbb74] to-[#c49a4c] py-[3px] pl-[6px] pr-[7px] align-middle text-[10px] font-medium uppercase leading-none tracking-[0.14em] text-[#2a1f0b] shadow-[inset_0_0_0_1px_rgba(255,240,205,0.35)]',
        className,
      )}
      title={title}
    >
      <Crown className="h-2.5 w-2.5 fill-current" strokeWidth={1.5} aria-hidden="true" />
      <span className="-mr-[0.14em]">{VIP_LABEL}</span>
      {srText ? <span className="sr-only">{srText}</span> : null}
    </span>
  );
}

VipPill.propTypes = {
  title: PropTypes.string,
  srText: PropTypes.string,
  className: PropTypes.string,
};
